import { render, staticRenderFns } from "./miniproMessage_node_form.vue?vue&type=template&id=675fb214&"
import script from "./miniproMessage_node_form.vue?vue&type=script&lang=js&"
export * from "./miniproMessage_node_form.vue?vue&type=script&lang=js&"
import style0 from "./miniproMessage_node_form.vue?vue&type=style&index=0&id=675fb214&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports